import apiClient from '../helpers/apiClient'

// WP-X6 — Engagement lifecycle (Book an Expert). Against the DEPLOYED #43 Engagement API
// (/api/v1/expertise/engagements/, EngagementViewSet). Payment is HELD (X3) — reaching AGREED
// stops at the awaiting-payment boundary; NOTHING here charges.
//
// Contract (camelCased by djangorestframework_camel_case):
//   POST   /expertise/engagements/                { expertMember?|expertPartner?, scope,
//                                                   agreedAmount?, currency?, terms?, cancellationTerms? }
//                                                 -> Engagement (201). Exactly one expert; no self-book.
//   GET    /expertise/engagements/?role=client|expert   -> [Engagement]  ("my engagements")
//   GET    /expertise/engagements/<id>/           -> Engagement (party, or admin read-only)
//   PATCH  /expertise/engagements/<id>/           edit while PROPOSED (either party; resets confirms)
//   POST   /expertise/engagements/<id>/confirm/   -> Engagement   (mutual confirm -> AGREED, locks)
//   POST   /expertise/engagements/<id>/unconfirm/ -> Engagement
//   POST   /expertise/engagements/<id>/cancel/    -> Engagement
//
//   Engagement = { id, client:{id,name,email}, expertMember:{id,name,email}|null,
//     expertPartner:{id,companyName}|null, scope, agreedAmount, currency, terms, cancellationTerms,
//     status, clientConfirmed, expertConfirmed, agreedAt, cancelledAt,
//     paymentSchedules:[{id,triggerType,amount,currency,status}], myRole:'client'|'expert'|null,
//     createdAt, updatedAt }

const BASE = '/expertise/engagements/'

export interface CreateEngagementPayload {
  expertMember?: number
  expertPartner?: number
  scope: string
  agreedAmount?: number | null
  currency?: string
  terms?: string
  cancellationTerms?: string
}

export interface EditEngagementPayload {
  scope?: string
  agreedAmount?: number | null
  currency?: string
  terms?: string
  cancellationTerms?: string
}

export const createEngagement = async (payload: CreateEngagementPayload) => {
  const response = await apiClient.post(BASE, payload)
  return response.data
}

export const getEngagements = async (role?: 'client' | 'expert') => {
  const response = await apiClient.get(BASE, {params: role ? {role} : {}})
  return response.data
}

export const getEngagement = async (id: number | string) => {
  const response = await apiClient.get(`${BASE}${id}/`)
  return response.data
}

export const updateEngagement = async (id: number | string, payload: EditEngagementPayload) => {
  const response = await apiClient.patch(`${BASE}${id}/`, payload)
  return response.data
}

export const confirmEngagement = async (id: number | string) => {
  const response = await apiClient.post(`${BASE}${id}/confirm/`)
  return response.data
}

export const unconfirmEngagement = async (id: number | string) => {
  const response = await apiClient.post(`${BASE}${id}/unconfirm/`)
  return response.data
}

export const cancelEngagement = async (id: number | string) => {
  const response = await apiClient.post(`${BASE}${id}/cancel/`)
  return response.data
}
